import { env } from "process";

const ENV = {
    dev: {
      apiUrl: 'http://188.121.111.197',
      oAuthConfig: {
        clientId: 'Arvan_react_Prod',
        scope: 'openid%20profile%20WMS%20role%20email%20phone',
        recirect:'http://188.121.110.83/authentication/login-callback',
        responseType:'code',
        clientSecret:"",
        grantType: "client_credentials"
      },
      localization: {
        defaultResourceName: 'wms',
      },
    },
    local: {
      apiUrl: 'https://localhost:44389',
      oAuthConfig: {
        clientId: 'WMS_App',
        scope: 'openid%20profile%20WMS%20role%20email%20phone',
        recirect:'https://localhost:4200/authentication/login-callback',
        responseType:'code',
        clientSecret:"N7JJPStoLr0Hrjpp",
        grantType: "authorization_code"
      },
      localization: {
        defaultResourceName: 'wms',
      },
    },
    prod: {
      apiUrl: 'https://api.aassttiinn.org',
      oAuthConfig: {
        clientId: 'ClientProd',
        scope: 'openid%20profile%20WMS%20role%20email%20phone',
        recirect:'https://aassttiinn.org/authentication/login-callback',
        responseType:'code',
        grantType: "authorization_code",
        clientSecret:"N7JJPStoLr0Hrjpp",
      },
      localization: {
        defaultResourceName: 'wms',
      },
    },
  };
  
  export const getEnvVars = () => {
    // eslint-disable-next-line no-undef
    return ENV.prod;
  };
  